/* eslint-disable */

import axios from 'axios';
import router from '../route';
import store from '../store/store';
import toast from './toast';

// Prevent duplicate error toasts
let isErrorToastVisible = false;

function showErrorToast(message, title) {
  if (isErrorToastVisible) {
    return;
  }

  isErrorToastVisible = true;

  toast.error(message, title);

  // Allow next error toast after 3 seconds
  setTimeout(() => {
    isErrorToastVisible = false;
  }, 3000);
}

// Axios Interceptor for response handling
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {

    // Ignore cancelled requests
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }

    const { response } = error;

    // Network Error / Timeout
    if (!response) {
      showErrorToast(
        'Network error or request timed out. Please check your internet connection.'
      );
      return Promise.reject(error);
    }

    const { status, data } = response;

    switch (status) {

      case 400:
        if (data && data.code === 1000) {

          if (data.data && data.data.email) {
            showErrorToast(data.data.email[0], 'Email Error');

          } else if (data.data && data.data.password) {
            showErrorToast(data.data.password.msg, 'Password Error');

          } else if (
            data.data &&
            data.data.profile &&
            data.data.profile.mobile
          ) {
            showErrorToast(data.data.profile.mobile[0], 'Mobile Error');

          } else {
            showErrorToast(
              'Validation error occurred. Please check your input.'
            );
          }

        } else if (data && data.non_field_errors) {

          showErrorToast(
            data.non_field_errors[0] || 'Bad Request'
          );

        } else {

          showErrorToast(
            data.user_msg || data.msg || 'Bad Request occurred. Please try again.'
          );
        }

        break;

      case 401:
        showErrorToast(
          data.user_msg || data.msg || 'Your session expired. Please log in again.'
        );

        store.dispatch('logoutManual');
        break;

      case 403:

        if (data && data.code === 8003) {

          showErrorToast(
            data.msg || 'Access forbidden. Please log in again.'
          );

          store.dispatch('logoutManual');

        } else {

          showErrorToast(
            data.msg || 'You do not have permission to access this resource.'
          );

        }

        break;

      case 415:
        showErrorToast(
          data.user_msg || data.msg || 'The media type of your request is not supported.'
        );
        break;

      case 500:
        showErrorToast(
          data.user_msg || data.msg || 'An internal server error occurred. Please try again later.'
        );
        break;

      case 502:
        showErrorToast(
          data.user_msg || data.msg || 'Bad Gateway. The server received an invalid response from an upstream server.'
        );
        break;

      case 503:
        showErrorToast(
          data.user_msg || data.msg || 'Service unavailable. The server is currently unable to handle the request.'
        );
        break;

      case 405:
        showErrorToast(
          data.user_msg ||
          data.msg ||
          `An unexpected error occurred (Status: ${status}).`
        );
        break;

      default:
        showErrorToast(
          data.user_msg ||
          data.msg ||
          `An unexpected error occurred (Status: ${status}).`
        );
        break;
    }

    return Promise.reject(error);
  }
);